
import {PairIterator} from "./pair.iterator";
import {RoomConfigurationInterface} from "../services/configuration.loader";

export class RoomsIterator extends PairIterator<RoomConfigurationInterface>
{

}


// WEBPACK FOOTER //
// ./src/app/utils/room.iterator.ts